'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OptInBanner = require('./components/OptInBanner.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OptInBanner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/components/opt-in-banner/index.js
// module id = 1435
// module chunks = 1